import { render, staticRenderFns } from "./Grafico.vue?vue&type=template&id=5dcd0856&"
import script from "./Grafico.vue?vue&type=script&lang=js&"
export * from "./Grafico.vue?vue&type=script&lang=js&"
import style0 from "./Grafico.vue?vue&type=style&index=0&id=5dcd0856&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports